import { Outlet } from 'react-router-dom';
import { SiteHeader } from '@/features/landing/components/SiteHeader';
import { SiteFooter } from '@/features/landing/components/SiteFooter';
import { SkipLink } from '@/shared/ui/primitives';
import type { ReactNode } from 'react';

/**
 * Public-marketing shell for the non-landing public pages (/register, /plans,
 * /unauthorized, …). Uses the SAME header/footer as the landing (SiteHeader +
 * SiteFooter) so the public surface is one consistent system — the header nav
 * routes to the landing anchors (/#features …) and works from every page.
 *
 * SiteHeader is `fixed`, so the content gets `pt-20` to clear the bar. The
 * `flex min-h-screen flex-col` wrapper lets `<main className="flex-1">` push
 * the footer to the viewport floor on short pages.
 *
 * RTL- and theme-aware via CSS variables.
 */
export function PublicLayout(): ReactNode {
  return (
    <div className="flex min-h-screen flex-col bg-surface-base">
      <SkipLink />
      <SiteHeader />
      <main id="main-content" tabIndex={-1} className="flex-1 pt-20">
        <Outlet />
      </main>
      <SiteFooter year={new Date().getFullYear()} />
    </div>
  );
}
